import { Option } from 'api/types/_public';
import CopyWrapper from 'components/Common/CopyWrapper';
import DropdownOption from 'components/Common/DropdownOption';
import DropdownOptionMemo from 'components/Common/DropdownOptionMemo';
import DropdownSelectMultiOption from 'components/Common/DropdownSelectMultiOption';
import LabelWrapper from 'components/Common/LabelWrapper';
import { useRole } from 'components/Hooks/UserHooks';
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { formatNumberWithCommas } from 'helpers/format';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import ModalImport from 'pages/NewsTravel/TravelPlace/components/ModalImport';
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from 'react-countup';
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CardBody, CardHeader, Col, Input, Row, Spinner } from "reactstrap";
import { createSelector } from "reselect";
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import TableContainer from "../../../components/Common/TableContainer";
import { getAllCategoryTravel, getAllPlaceTravel, getAllTagTravel, getPlaceTravels as onGetPlaceTravels } from "../../../store/thunks";
import ModalConfigGenerate from './components/ModalConfigGenerate';
import ModalGenerate from './components/ModalGenerate';
import ShowMoreText from './components/ShowMoreText';

export interface Tag {
    id: string;
    text: string;
}

const TYPE_SELECT_DEFAULT: string = 'popularity';

registerLocale('en', en);
registerLocale('ko', ko);

const ArticleList = (activeTab?: any) => {
    let document_w: any = window.document;
    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();

    const [query, setQuery]: any = useQueryParams({
        time_request: withDefault(NumberParam, 0),
        page: withDefault(NumberParam, 1),
        limit: withDefault(NumberParam, 30),
        sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
        order_by: withDefault(StringParam, 'DESC'),
        name: withDefault(StringParam, ''),
        categories: withDefault(StringParam, ''),
        review_tags: withDefault(StringParam, ''),
        provinces: withDefault(StringParam, ''),
        cities: withDefault(StringParam, ''),
        districts: withDefault(StringParam, ''),
    });

    const [nameSearch, setNameSearch] = useState<string>(query?.name || "");

    const [placeSearch, setPlaceSearch] = useState<any>(null);
    const [provinceSpecialCitySearch, setProvinceSpecialCitySearch] = useState<any>(null);
    const [cityCountyDistrictSearch, setCityCountyDistrictSearch] = useState<any>(null);
    const [townTownshipNeighborhoodSearch, setTownTownshipNeighborhoodSearch] = useState<any>(null);
    const [categorySearch, setCategorySearch] = useState<any>(null);
    const [tagSearch, setTagSearch] = useState<any>(null);

    const [listCategory, setListCategory] = useState<any[]>([]);
    const [listTag, setListTag] = useState<any[]>([]);

    const [listPlace, setListPlace] = useState<any[]>([]);
    const [listProvince, setListProvince] = useState<any[]>([]);
    const [listCity, setListCity] = useState<any[]>([]);
    const [listDistrict, setListDistrict] = useState<any[]>([]);

    const [optionsSelected, setOptionsSelected] = useState<any>([]);

    const [isOpenModalImport, setIsOpenModalImport] = useState<boolean>(false);

    const [isOpenModalGenerate, setIsOpenModalGenerate] = useState<boolean>(false);
    const [sources, setSources] = useState<any[]>([]);

    const [isOpenModalConfigPrompt, setIsOpenModalConfigPrompt] = useState<boolean>(false);

    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => state.News;

    const PlaceTravelProperties = createSelector(
        selectLayoutState,
        (state) => ({
            placeTravels: state.placeTravels,
            isPlaceTravelSuccess: state.isPlaceTravelSuccess,
            isPlaceTravelLoading: state.isPlaceTravelLoading,
        })
    );

    // Inside your component
    const { placeTravels, isPlaceTravelLoading } = useSelector(PlaceTravelProperties);

    useEffect(() => {
        dispatch(onGetPlaceTravels(query));
    }, [JSON.stringify(query)]);

    const searchData = (_prev: any = {}) => {
        const queryNew = {
            name: nameSearch || '',
            categories: categorySearch ? categorySearch?.map((item: any) => item.value).join(',') : '',
            review_tags: tagSearch ? tagSearch?.map((item: any) => item.value).join(',') : '',
            provinces: provinceSpecialCitySearch ? provinceSpecialCitySearch?.map((item: any) => item.value).join(',') : '',
            cities: cityCountyDistrictSearch ? cityCountyDistrictSearch?.map((item: any) => item.value).join(',') : '',
            districts: townTownshipNeighborhoodSearch ? townTownshipNeighborhoodSearch?.map((item: any) => item.value).join(',') : '',
            page: 1,
            time_request: + new Date(),
            ..._prev
        };
        setQuery(queryNew);
        setOptionsSelected((prev: any) => []);
    };

    const resetData = () => {
        const queryNew = {
            name: '',
            categories: '',
            review_tags: '',
            provinces: '',
            cities: '',
            districts: '',
            order_by: 'DESC',
            sort_by: TYPE_SELECT_DEFAULT,
            time_request: + new Date(),
            page: 1,
        };
        setQuery(queryNew, "push");
        setNameSearch((_prev: any) => "");
        setCategorySearch((_prev: any) => null);
        setTagSearch((_prev: any) => null);
        setProvinceSpecialCitySearch((_prev: any) => null);
        setCityCountyDistrictSearch((_prev: any) => null);
        setTownTownshipNeighborhoodSearch((_prev: any) => null);
        setPlaceSearch((_prev: any) => null);
    };

    const triggerRefresh = async () => {
        setIsOpenModalGenerate(false);
        setSources([]);
        setOptionsSelected((prev: any) => []);
    }
    //End::Update


    // Begin:: handle select table 
    const handleCheck = (valueCheck: Option, valueIndex: number | string, e: any = null) => {
        // if (!!isFirstLoadingPageRef.current) {
        //   return;
        // }
        const index = String(valueIndex);
        if (valueCheck?.value === 'ALL') {
            setOptionsSelected((prev: any) => {
                const prevClone = structuredClone(prev);
                if (e.target.checked) {
                    if (prevClone[index] === undefined) {
                        prevClone[index] = [];
                    }
                    prevClone[index] = (placeTravels?.list || [])?.map((item: any) => ({ value: item?.id, label: item?.name }));
                    return prevClone;
                } else {
                    prevClone[index] = [];
                    return prevClone;
                }
            });
            return;
        }
        if (!e.target.checked) {
            setOptionsSelected((prev: any) => {
                const prevClone = structuredClone(prev);
                if (prevClone[index] === undefined) {
                    prevClone[index] = [];
                }
                prevClone[index] = (prevClone[index] || [])?.filter((item: any) => (item?.value !== valueCheck?.value));
                return prevClone;
            });
        } else {
            setOptionsSelected((prev: any) => {
                const prevClone = structuredClone(prev);
                if (prevClone[index] === undefined) {
                    prevClone[index] = [];
                }
                prevClone[index] = ([...prevClone[index], valueCheck]);
                return prevClone;
            });
        }
    };

    const isChecked = (valueCheck: Option) => {
        const index = String(query.page);
        return !!(optionsSelected[index]?.find((x: any) => x.value === valueCheck?.value)?.value);
    };

    const isCheckedAll = (valueIndex: string) => {
        const valueIndexString = String(valueIndex);
        return (optionsSelected[valueIndexString]?.length > 0 && optionsSelected[valueIndexString]?.length === placeTravels?.list?.length);
    };

    const countRowSelected = useMemo(() => {
        return Object.entries(optionsSelected)?.reduce((total: number, [key, value]: any) => {
            return Number(total + (value || [])?.length);
        }, 0)
    }, [optionsSelected]);

    // End:: handle select table 

    // Column
    const columns = useMemo(
        () => [
            {
                Header: t('Key'),
                accessor: "",
                filterable: true,
                sortable: false,
                thClass: 'text-start align-middle',
                thWidth: 50,
                thComponent: () => (<>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" checked={isCheckedAll(query?.page)} onChange={(e) => handleCheck(({ value: 'ALL', label: '' }), query?.page, e)} value="" id={`cell-check-all`} />
                        <label className="form-check-label" htmlFor={`cell-check-all`}></label>
                    </div>
                </>
                ),
                Cell: (cell: any) => {
                    const item: any = cell?.row?.original;
                    return (
                        <>
                            <div className={`form-check`}>
                                <input className="form-check-input" type="checkbox" name="table" checked={isChecked({ value: item?.id, label: item?.name })} value={item?.id ?? ''} onChange={(e) => handleCheck(({ value: item?.id, label: item?.name }), query?.page, e)} id={`cell-check-${item?.id ?? ''}`} />
                                <label className="form-check-label" htmlFor={`cell-check-${item?.id ?? ''}`}></label>
                            </div>
                        </>
                    )
                },
            },
            {
                Header: t('ID'),
                accessor: "id",
                filterable: true,
                sortable: true,
                thWidth: 120,
                thClass: "align-middle text-center",
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <>
                            <div className="text-center" style={{ minWidth: '100px' }}>
                                <CopyWrapper contentCopy={item?.naver_place_id}>
                                    {item?.naver_place_id}
                                </CopyWrapper>
                            </div>

                        </>
                    )
                },
            },
            {
                Header: t('Place Name'),
                accessor: "name",
                filterable: true,
                sortable: true,
                thWidth: 160,
                thClass: 'align-middle text-start',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<div style={{ minWidth: '140px' }}>
                        {cell?.value || '-'}
                    </div>)
                },
            },
            {
                Header: t('Category'),
                accessor: "original_category",
                filterable: true,
                sortable: false,
                thWidth: 130,
                thClass: 'align-middle text-start',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<div style={{ minWidth: '100px' }}>
                        {cell?.value || '-'}
                    </div>)
                },
            },
            {
                Header: t('Address'),
                accessor: "address",
                filterable: true,
                sortable: true,
                thWidth: 200,
                thClass: 'align-middle text-start',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<div style={{ minWidth: '200px' }}>
                        {cell?.value || '-'}
                    </div>)
                },
            },
            {
                Header: t('Keywords'),
                accessor: "keywords",
                filterable: true,
                sortable: false,
                thWidth: 130,
                thClass: 'align-middle text-start',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<div style={{ minWidth: '100px' }}>
                        {cell?.value || '-'}
                    </div>)
                },
            },
            {
                Header: t('Number of Reviews'),
                accessor: "popularity",
                filterable: true,
                sortable: true,
                thWidth: 130,
                thClass: 'align-middle text-center',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<div style={{ minWidth: '100px' }} className="text-center">
                        {formatNumberWithCommas(Number(item?.total_blog_reviews_count) + Number(item?.total_visitor_reviews_count))}
                    </div>)
                },
            },
            {
                Header: t('Review Summary'),
                accessor: "visitor_reviews",
                filterable: true,
                sortable: false,
                thWidth: 220,
                thClass: 'align-middle text-start',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<div style={{ minWidth: '200px' }}>
                        <ShowMoreText text={cell?.value || '-'} maxLines={3} />
                    </div>)
                },
            },
            {
                Header: t('Description(naver)'),
                accessor: "introduction",
                filterable: true,
                sortable: false,
                thWidth: 320,
                thClass: 'align-middle text-start',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <div style={{ minWidth: '300px' }}>
                            <ShowMoreText text={cell?.value || '-'} maxLines={3} />
                        </div>)
                },
            },
            {
                Header: t('Description(visitkorea)'),
                accessor: "description",
                filterable: true,
                sortable: false,
                thWidth: 320,
                thClass: 'align-middle text-start',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <div style={{ minWidth: '300px' }}>
                            <ShowMoreText text={cell?.value || '-'} maxLines={3} />
                        </div>)
                },
            },
            // {
            //     Header: t('Created At'),
            //     accessor: "created_at",
            //     filterable: true,
            //     sortable: true,
            //     thWidth: 130,
            //     thClass: 'align-middle text-end',
            //     Cell: (cell: any) => {
            //         const arrDate = String(cell?.value || '').split(' ');
            //         return (
            //             <div className="text-end pe-3" style={{ minWidth: '120px' }}>
            //                 <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
            //             </div>
            //         )
            //     },
            // },
            {
                Header: t('Updated at'),
                accessor: "updated_at",
                filterable: true,
                sortable: true,
                thWidth: 150,
                thClass: 'text-end align-middle',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (
                        <div className="text-end pe-3" style={{ minWidth: '100px' }}>
                            <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
                        </div>
                    )
                },
            }
        ],
        [i18n?.language, JSON.stringify(query), placeTravels?.list?.length, JSON.stringify(userPermissions), JSON.stringify(optionsSelected)]
    );

    const handleChangePage = useCallback((page: any) => {
        setQuery({ page: page + 1 })
    }, []);

    const handleChangeSorting = useCallback((sortBy: any) => {
        setQuery((_prev: any) => {
            return ({ ..._prev, ...sortBy });
        });
    }, []);

    const changeLimitPerPage = (limit: number) => {
        if (String(limit) === String(query?.limit)) {
            return;
        }
        const queryNew = {
            ...query,
            limit: limit,
            time_request: + new Date(),
            page: 1,
        };
        setQuery(queryNew, "push");
        setOptionsSelected((prev: any) => []);
    };


    const handleCallAllOption = async () => {
        try {
            const [res1, res2, res3]: any = await Promise.all([getAllCategoryTravel(), getAllPlaceTravel(), getAllTagTravel()]);

            const _listCategory = (res1?.data || [])?.map((_c: any) => ({ label: _c?.name, value: `${_c?.name}` }));
            const _listTag = (res3?.data || [])?.map((_t: any) => ({ label: _t?.name, value: `${_t?.name}` }));
            setListCategory((_prev) => _listCategory || []);
            setListTag((_prev) => _listTag || []);

            const _paramCategory = query?.categories ? query?.categories?.split(',')?.map((item: any) => String(item).trim()) : null;
            const _paramTag = query?.review_tags ? query?.review_tags?.split(',')?.map((item: any) => String(item).trim()) : null;

            const _searchCategory = _listCategory?.filter((item: any) => _paramCategory?.includes(String(item.value)));
            const _searchTag = _listTag?.filter((item: any) => _paramTag?.includes(String(item.value)));
            setCategorySearch(_searchCategory);
            setTagSearch(_searchTag);

            const _tree = res2?.data?.tree;
            const _list = (res2?.data?.list || [])?.map((_p: any) => ({ label: _p, value: `${_p}` }));
            const _listProvince = _tree?.map((_p: any) => ({ label: _p?.name, province_id: `${_p?.id}`, value: `${_p?.name}` }));
            const _listCity = _tree?.flatMap((_p: any) => _p?.cities?.map((_c: any) => ({ label: _c?.name, province_id: `${_p?.id}`, city_id: `${_c?.id}`, value: `${_c?.name}` })));
            const _listDistrict = _tree?.flatMap((_p: any) => _p?.cities?.flatMap((_c: any) => _c?.districts?.map((_d: any) => ({ label: _d?.name, province_id: `${_p?.id}`, city_id: `${_c?.id}`, district_id: `${_d?.id}`, value: `${_d?.name}` }))));

            setListProvince((_prev) => _listProvince || []);
            setListCity((_prev) => _listCity || []);
            setListDistrict((_prev) => _listDistrict || []);
            setListPlace((_prev) => _list || []);

            const _paramProvince = query?.provinces ? query?.provinces?.split(',')?.map((item: any) => String(item).trim()) : null;
            const _paramCity = query?.cities ? query?.cities?.split(',')?.map((item: any) => String(item).trim()) : null;
            const _paramDistrict = query?.districts ? query?.districts?.split(',')?.map((item: any) => String(item).trim()) : null;

            const _searchProvince = _listProvince?.filter((item: any) => _paramProvince?.includes(String(item.value)));
            const _searchCity = _listCity?.filter((item: any) => _paramCity?.includes(String(item.value)));
            const _searchDistrict = _listDistrict?.filter((item: any) => _paramDistrict?.includes(String(item.value)));

            setProvinceSpecialCitySearch(_searchProvince);
            setCityCountyDistrictSearch(_searchCity);
            setTownTownshipNeighborhoodSearch(_searchDistrict);
        } catch (error: any) {
            return error;
        }
    };

    const listCityFilter = useMemo(() => {
        const _provinceIds = (provinceSpecialCitySearch || [])?.map((item: any) => String(item.province_id));
        return listCity?.filter((_c: any) => (_provinceIds?.includes(String(_c?.province_id)) || !_provinceIds?.length));
    }, [listCity, provinceSpecialCitySearch]);

    const listDistrictFilter = useMemo(() => {
        const _cityIds = (cityCountyDistrictSearch || [])?.map((item: any) => String(item.city_id));
        return listDistrict?.filter((_d: any) => (_cityIds?.includes(String(_d?.city_id)) || !_cityIds?.length));
    }, [listDistrict, provinceSpecialCitySearch, cityCountyDistrictSearch]);

    const handleChangePlaceSearch = useCallback((e: any) => {
        if (isPlaceTravelLoading) return;
        const _value = e?.value || '';
        const _places = _value?.split('>')?.map((_v: any) => String(_v).trim());
        const _province = listProvince?.filter((_p: any) => String(_p?.value) === String(_places?.[0])) || null;
        const _city = listCity?.filter((_c: any) => String(_c?.value) === String(_places?.[1])) || null;
        const _district = listDistrict?.filter((_d: any) => String(_d?.value) === String(_places?.[2])) || null;
        setProvinceSpecialCitySearch((_prev: any) => _province);
        setCityCountyDistrictSearch((_prev: any) => _city);
        setTownTownshipNeighborhoodSearch((_prev: any) => _district);
        searchData(
            {
                provinces: _province ? _province?.map((item: any) => item.value).join(',') : '',
                cities: _city ? _city?.map((item: any) => item.value).join(',') : '',
                districts: _district ? _district?.map((item: any) => item.value).join(',') : '',
                page: 1,
            }
        );
    }, [isPlaceTravelLoading, listProvince, listCity, listDistrict]);

    const handleShowModalGenerate = () => {
        const sources = (optionsSelected || []).flat()?.map((item: any) => item);
        setSources(sources || []);
        setIsOpenModalGenerate(true);
    }

    const handleShowModalImport = () => {
        setIsOpenModalImport(true);
    }

    useEffect(() => {
        handleCallAllOption();
    }, []);

    useEffect(() => {
        document.body.classList.remove('vertical-sidebar-enable');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);

    const optionPlace = useMemo(() => {
        return listPlace?.map((item: any) => ({ label: item?.label, value: item?.value }));
    }, [JSON.stringify(listPlace)]);

    return (
        <React.Fragment>
            <Row>
                {isHavePermissionRole(ROLES_FOR_APP.NEWS_TRAVEL, userPermissions) && (
                    <Col lg={12}>
                        <div>
                            <CardHeader className="border-0">
                                <Row className="g-4 align-items-center">
                                    <div className="col-sm-5">
                                        <div>
                                            <h5 className="card-title mb-0">
                                                <span>
                                                    <span className="me-2">{t('Total')}:</span>
                                                    {(isPlaceTravelLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                                        start={0}
                                                        end={Number(placeTravels?.pagination?.total || 0)}
                                                        duration={1}
                                                        className="text-primary"
                                                    />)}
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="col-sm-7 text-end">
                                        {isHavePermissionRole(ROLES_FOR_APP.NEWS_TRAVEL, userPermissions) && (<button
                                            type="button"
                                            className="btn btn-success add-btn rounded-pill mb-2 mb-sm-0"
                                            onClick={() => handleShowModalImport()}
                                        >
                                            <i className="ri-upload-line align-bottom"></i>
                                            <span className="ms-1">{t('Button Import Bulk Generate Travel News')}</span>
                                        </button>)}
                                        {isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS_TRAVEL, userPermissions) && (<button
                                            type="button"
                                            className="btn btn-primary add-btn rounded-pill ms-2"
                                            onClick={() => setIsOpenModalConfigPrompt((_prev: any) => true)}
                                        >
                                            <i className="ri-settings-line align-bottom"></i>
                                            <span className="ms-1">{t('Config Generate')}</span>
                                        </button>)}
                                    </div>
                                </Row>
                            </CardHeader>
                            <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                                <Row className="g-4 align-items-center mt-0">
                                    <Col xs={7} sm={6} md={6} lg={4} xl={4} xxl={2} className='mt-md-2'>
                                        <LabelWrapper label={t('Location search')} isShow={!!placeSearch}>
                                            <DropdownOptionMemo
                                                name={`place`}
                                                dataList={optionPlace}
                                                placeholder={`${t("Location search")}...`}
                                                className="search-filter-category-type dropdown-status-rounded"
                                                classNamePrefix="name-prefix"
                                                initialValue={placeSearch || { label: t('All'), value: '' }}
                                                isHaveMoreInfo={true}
                                                onChangeSelect={(e: any) => {
                                                    setPlaceSearch(e);
                                                    if (e !== null) {
                                                        handleChangePlaceSearch(e);
                                                    }
                                                }}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    {/* <Col xs={5} sm={6} md={6} lg={8} xl={8} xxl={10} className='mt-md-2 text-start'>
                                        <button
                                            type="button"
                                            className="btn btn-light"
                                            onClick={() => handleChangePlaceSearch()}
                                        // disabled={isNewsTravelLoading}
                                        >
                                            <i className="ri-map-pin-line align-bottom me-1"></i>{" "}
                                            {t('Select Location')}
                                        </button>
                                    </Col> */}
                                </Row>
                                <Row className="g-4 align-items-center mt-3">
                                    <Col sm={6} md={6} lg={4} xl={2} xxl={2} className='mt-3 mt-xl-2 order-1 order-xl-0'>
                                        <LabelWrapper label={t('Place Name')} isShow={true}>
                                            <Input
                                                type="text"
                                                className="form-control search"
                                                placeholder={`${t("Place Name")}...`}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        searchData();
                                                    }
                                                }}
                                                value={nameSearch}
                                                onChange={(e) => setNameSearch(e.target.value)}
                                                autoComplete="off"
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={6} md={6} lg={4} xl={2} xxl={2} className='mt-3 mt-xl-2'>
                                        <LabelWrapper label={t('Province / Special City')} isShow={true}>
                                            <DropdownSelectMultiOption
                                                name={`province_special_city`}
                                                dataList={listProvince}
                                                placeholder={`${t("Province / Special City")}...`}
                                                className="dropdown-status-rounded"
                                                classNamePrefix="name-prefix"
                                                isHaveMoreInfo={true}
                                                initialValue={provinceSpecialCitySearch || null}
                                                onChangeSelect={(e: any) => {
                                                    setProvinceSpecialCitySearch(e)
                                                }}
                                                isHasOptionAll={true}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={6} md={6} lg={4} xl={2} xxl={2} className='mt-3 mt-xl-2'>
                                        <LabelWrapper label={t('City / County / District')} isShow={true}>
                                            <DropdownSelectMultiOption
                                                name={`city_county_district`}
                                                dataList={listCityFilter}
                                                placeholder={`${t("City / County / District")}...`}
                                                className="search-filter-category-type dropdown-status-rounded"
                                                classNamePrefix="name-prefix"
                                                initialValue={cityCountyDistrictSearch || null}
                                                isHaveMoreInfo={true}
                                                onChangeSelect={(e: any) => {
                                                    setCityCountyDistrictSearch(e)
                                                }}
                                                isHasOptionAll={true}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={6} md={6} lg={4} xl={2} xxl={2} className='mt-3 mt-xl-2'>
                                        <LabelWrapper label={t('Town / Township / Neighborhood')} isShow={true}>
                                            <DropdownSelectMultiOption
                                                name={`town_township_neighborhood`}
                                                dataList={listDistrictFilter}
                                                placeholder={`${t("Town / Township / Neighborhood")}...`}
                                                className="search-filter-category-type dropdown-status-rounded"
                                                classNamePrefix="name-prefix"
                                                initialValue={townTownshipNeighborhoodSearch || null}
                                                isHaveMoreInfo={true}
                                                onChangeSelect={(e: any) => {
                                                    setTownTownshipNeighborhoodSearch(e)
                                                }}
                                                isHasOptionAll={true}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={6} md={6} lg={4} xl={2} xxl={2} className='mt-3 mt-xl-2 order-sm-2 order-xl-0'>
                                        <LabelWrapper label={t('Category')} isShow={true}>
                                            <DropdownSelectMultiOption
                                                name={`category`}
                                                dataList={listCategory}
                                                placeholder={`${t("Category")}...`}
                                                className="search-filter-category-type dropdown-status-rounded"
                                                classNamePrefix="name-prefix"
                                                initialValue={categorySearch || null}
                                                isHaveMoreInfo={true}
                                                onChangeSelect={(e: any) => {
                                                    setCategorySearch(e)
                                                }}
                                                isHasOptionAll={true}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={6} md={6} lg={4} xl={2} xxl={2} className='mt-3 mt-xl-2 order-sm-2 order-xl-0'>
                                        <LabelWrapper label={t('Tag')} isShow={true}>
                                            <DropdownSelectMultiOption
                                                name={`tag`}
                                                dataList={listTag}
                                                placeholder={`${t("Tag")}...`}
                                                className="search-filter-category-type dropdown-status-rounded"
                                                classNamePrefix="name-prefix"
                                                initialValue={tagSearch || null}
                                                isHaveMoreInfo={true}
                                                onChangeSelect={(e: any) => {
                                                    setTagSearch(e)
                                                }}
                                                isHasOptionAll={true}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={12} md={12} lg={12} xl={12} xxl={12} className="hstack gap-1 justify-content-center justify-content-sm-end mt-3 order-3 order-xl-1">
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-primary me-2 "
                                                onClick={searchData}
                                                disabled={isPlaceTravelLoading}
                                            >
                                                <i className="ri-search-line align-bottom me-1"></i>{" "}
                                                {t('Button Search')}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary fs-14"
                                                onClick={resetData}
                                            >
                                                <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                {t('Button Reset')}
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="border border-dashed border-top-0 border-end-0 border-start-0 px-3 py-3">
                                <Col sm={12} md={12} xl={12} className="my-0 mt-2 mt-md-0 text-start d-flex flex-wrap gap-3 justify-content-between align-items-center">
                                    {isHavePermissionRole(ROLES_FOR_APP.NEWS_TRAVEL, userPermissions) && <div
                                        className='d-flex flex-wrap gap-3 justify-content-between align-items-center'
                                    >
                                        <button
                                            type="button"
                                            className="btn btn-soft-success"
                                            // style={{ width: i18n?.language === 'en' ? '145px' : '90px' }}
                                            disabled={countRowSelected <= 0}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleShowModalGenerate();
                                            }}
                                        >
                                            {countRowSelected > 0 && (
                                                <span
                                                    className="position-absolute topbar-badge badge rounded-pill bg-danger"
                                                    style={{ transform: "translate(0%, -70%)" }}
                                                >
                                                    {formatNumberWithCommas(countRowSelected)}
                                                    <span className="visually-hidden">
                                                        total news selected
                                                    </span>
                                                </span>
                                            )}
                                            {t('Generate News')}
                                        </button>
                                    </div>}
                                    <div className="mt-3 mt-md-0">
                                        <LabelWrapper label={t('Showcase')} isShow={true}>
                                            <DropdownOption
                                                name="showcase"
                                                dataList={[{ label: '30', value: '30' }, { label: '50', value: '50' }, { label: '100', value: '100' }]}
                                                placeholder={`${t("Showcase")}...`}
                                                className={`dropdown-status-rounded z-hight-100`}
                                                classNamePrefix="name-prefix"
                                                style={{ width: '85px' }}
                                                initialValue={{ label: `${query?.limit}`, value: `${query?.limit}` }}
                                                onChangeSelect={(e: any) => {
                                                    changeLimitPerPage(e?.value);
                                                }}
                                            />
                                        </LabelWrapper>
                                    </div>
                                </Col>
                            </div>
                            <CardBody className="pt-3">
                                <TableContainer
                                    className="custom-header-css"
                                    divClass="table-responsive table-card"
                                    tableClass="align-middle sticky-table-travel-news"
                                    theadClass="table-light"
                                    columns={columns}
                                    data={placeTravels?.list?.length ? placeTravels?.list : []}
                                    customPageSize={query.limit}
                                    customPageIndex={query.page - 1}
                                    totalRecords={placeTravels?.pagination?.total}
                                    customPageCount={Math.ceil(Number(placeTravels?.pagination?.total) / Number(placeTravels?.pagination?.limit))}
                                    handleChangePage={handleChangePage}
                                    manualSorting={true}
                                    sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                                    handleChangeSorting={handleChangeSorting}
                                    isLoading={isPlaceTravelLoading}
                                    isShowHeaderTableFixedTab={activeTab}
                                />
                            </CardBody>
                        </div>
                    </Col>
                )}
            </Row>

            <ModalConfigGenerate
                isOpen={isOpenModalConfigPrompt}
                onClose={() => setIsOpenModalConfigPrompt((_prev: any) => false)}
            />

            <ModalGenerate
                isOpen={isOpenModalGenerate}
                onClose={() => setIsOpenModalGenerate(false)}
                onRefresh={() => triggerRefresh()}
                sourcesIds={sources}
            />

            <ModalImport
                isOpen={isOpenModalImport}
                onRefresh={triggerRefresh}
                onClose={() => setIsOpenModalImport(false)}
            />

            <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={3000} limit={2} />
        </React.Fragment >
    );
};

export default ArticleList;